export enum CodeTableEnum {
  DocumentCategories = 1,
  DocumentStatuses = 2,
  InstitutionTypes = 3,
  InstitutionStatuses = 4,
  LearningShifts = 5,
  PaymentStatuses = 6,
  StudentReportStatuses = 7,
  StudentTypes = 8,
  IndificationTypes = 9
}
